<ng-container *ngIf="!isGrowCustomer">
  <div class="header">
    <h1>{{ 'GROW.impactTab.title' | translate }}</h1>
    <p>{{ 'GROW.impactTab.createAccountDescription' | translate }}</p>
  </div>
  <div>
    <img src="/assets/images/grow/impactTab.png" alt="{{ 'GROW.impactTab.cta' | translate }}" />
    <app-ds-button (clicked)="goToGrowOnboarding()" class="cta">{{ 'GROW.impactTab.createGrowCTA' | translate }}</app-ds-button>
  </div>
</ng-container>

<ng-container *ngIf="isGrowCustomer">
  <ng-container *ngIf="growProjects.length > 0; else browseProjects">
    <div class="header">
      <h1>{{ 'GROW.impactTab.title' | translate }}</h1>
      <p>{{ 'GROW.impactTab.projectsInvestedDescription' | translate }}</p>
    </div>
    <ng-container *ngIf="growProjectsLoaded$ | async; else showLoadingBar">
      <div class="grow-projects">
        @for (project of growProjects; track project) {
          <div class="ds-card grow-project" (click)="showProjectImpactDetails(project)">
            <div>
              <div *ngIf="project.image" class="grow-project-image">
                <img [src]="project.image" alt="Project image" />
              </div>
              <h4 class="ds-caption-1" [innerHTML]="project.title"></h4>
            </div>
            <app-ds-button size="small" variant="outline">
              {{ 'GROW.project.buttons.viewDetails' | translate }}
            </app-ds-button>
          </div>
        }
      </div>
    </ng-container>

    <ng-template #showLoadingBar>
      <ion-skeleton-text animated style="height: 32px"></ion-skeleton-text>
    </ng-template>
  </ng-container>
  <ng-template #browseProjects>
    <div class="header">
      <h1>{{ 'GROW.impactTab.title' | translate }}</h1>
      <p>{{ 'GROW.impactTab.description' | translate }}</p>
    </div>
    <div>
      <img src="/assets/images/grow/impactTab.png" alt="{{ 'GROW.impactTab.cta' | translate }}" />
      <app-ds-button (clicked)="goToGrowProjects()" class="cta">{{ 'GROW.impactTab.cta' | translate }}</app-ds-button>
    </div>
  </ng-template>
</ng-container>
